import styles from './ResponseMapping.module.css';
import { AGENT_OUTCOME_COPY, requiredAgentOutcomeMappingSuggestion } from './agent-outcome-copy';

interface RequiredResponseMappingProps {
  outputName: string;
  suggestedPath: string | null;
  onApplySuggestion: (path: string, outputName: string) => void;
}

export const RequiredResponseMapping = ({
  outputName,
  suggestedPath,
  onApplySuggestion,
}: RequiredResponseMappingProps) => (
  <div className={styles.requiredMapping} role="alert">
    <div>
      <strong>{AGENT_OUTCOME_COPY.requiredMappingTitle}</strong>
      <p>
        {AGENT_OUTCOME_COPY.requiredMappingDescriptionLead} <code>{outputName}</code>{' '}
        {AGENT_OUTCOME_COPY.requiredMappingDescriptionTail}
      </p>
    </div>
    {suggestedPath ? (
      <button
        type="button"
        aria-label={requiredAgentOutcomeMappingSuggestion(suggestedPath, outputName)}
        onClick={() => onApplySuggestion(suggestedPath, outputName)}>
        {AGENT_OUTCOME_COPY.requiredMappingSuggestionLead} <code>{suggestedPath}</code>{' '}
        {AGENT_OUTCOME_COPY.requiredMappingSuggestionConnector} <code>{outputName}</code>
        <span> {AGENT_OUTCOME_COPY.requiredMappingSuggestionTail}</span>
      </button>
    ) : (
      <p>{AGENT_OUTCOME_COPY.requiredMappingSamplePrompt}</p>
    )}
  </div>
);
